import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';

@Directive({
	selector: '[hasPermission]',
})
export class HasPermissionDirective {
	private role: string;

	constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private jwtHelper: JwtHelperService, private router: Router) {}

	@Input('hasPermission') set hasPermission(hasPermission: any) {
		const token = localStorage.getItem('currentUser');
		if (!token) {
			this.router.navigate(['/login']);
			return;
		}

		try {
			this.role = this.jwtHelper.decodeToken(token).role;

			if (hasPermission === this.role) {
				this.viewContainer.createEmbeddedView(this.templateRef);
			} else {
				this.viewContainer.clear();
			}
		} catch (error) {
			console.error('Error decoding token or retrieving role', error);
			this.viewContainer.clear();
		}
	}
}
